const displayNames = new Map<string, string>();

/** Native name of the language (English, Deutsch, British English); the code itself when Intl cannot resolve it. */
export const getLanguageName = (language: string): string => {
  const cached = displayNames.get(language);

  if (cached) {
    return cached;
  }

  let name = language;

  try {
    name = new Intl.DisplayNames([language], { type: 'language' }).of(language) ?? language;
  } catch {
    // Unknown code or an environment without Intl.DisplayNames: keep the code.
  }

  displayNames.set(language, name);

  return name;
};
